module.exports = __webpack_public_path__ + "img/ScissorLift.1dc936a7.png";